import React from "react"
import { useHistory, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Home, Package, MoreHorizontal, ShoppingBag, Layers } from "react-feather"

import { ResolvedSection } from "../useMobileSections"

/** Bo'lim kodiga mos ikonka */
function iconFor(code: string) {
  switch (code) {
    case "sales":
    case "wSales":
      return ShoppingBag
    case "orders":
      return Package
    case "residues":
    case "purchases":
    case "wPurchases":
      return Layers
    default:
      return Package
  }
}

/**
 * Pastki menyu — namunadagi kabi beshta bo'lim.
 *
 * Birinchisi har doim bosh sahifa, oxirgisi "Yana", o'rtadagilari esa
 * admin sozlamasida belgilangan bo'limlar. Beshtadan ortiq bo'lsa
 * telefon ekranida yozuvlar bir-biriga kirib ketardi, shuning uchun
 * chegara qat'iy.
 */
export default function BottomNav({ tabs }: { tabs: ResolvedSection[] }) {
  const history = useHistory()
  const location = useLocation()
  const { t } = useTranslation()

  const items = [
    { key: "home", label: t("mobHome"), icon: Home, path: "/m" },
    ...tabs.map((s) => ({
      key: s.code,
      label: t(s.labelKey),
      icon: iconFor(s.code),
      path: `/m/${s.code}`,
    })),
    { key: "more", label: t("mobMore"), icon: MoreHorizontal, path: "/m/more" },
  ]

  return (
    <nav className="mb-nav">
      {items.map((item) => {
        const active =
          item.path === "/m"
            ? location.pathname === "/m" || location.pathname === "/m/"
            : location.pathname.startsWith(item.path)
        const Icon = item.icon
        return (
          <button
            key={item.key}
            type="button"
            className={`mb-nav-item${active ? " mb-nav-item--active" : ""}`}
            onClick={() => history.push(item.path)}
          >
            <Icon size={19} />
            <span>{item.label}</span>
          </button>
        )
      })}
    </nav>
  )
}
